export default {
  namespaced: true,
  state: {
    cleansingRule: {
      name: '',
      subscribed_ago: null,
      campaigns_receieved: null,
      campaigns_receieved_time: null,
      did_not_open_time: null,
      domain_names: '',
      opened_more_than: null
    },
    confirmDialog: false
  },
  mutations: {
    'cleansingRule': (state, value) => {
      state.cleansingRule = value;
    },
    'confirmDialog': (state, value) => {
      state.confirmDialog = value;
    }
  },
  getters: {
    cleansingRule: state => state.cleansingRule,
    confirmDialog: state => state.confirmDialog
  },
  actions:{
    resetStore ({ commit }) {
      let cleansingRule = {
        name: '',
        subscribed_ago: null,
        campaigns_receieved: null,
        campaigns_receieved_time: null,
        did_not_open_time: null,
        domain_names: '',
        opened_more_than: null
      }
      commit('cleansingRule', cleansingRule)
    }
  }
}